import React from 'react';

import { UserQuery } from '../../ts/@types/generated/graphql/rails/graphql';

export interface UserContextInterface {
  user: UserQuery['user'] | null;
  setUser: (user: UserQuery['user']) => void | null;
  tenantId: number;
}

const UserContext = React.createContext<UserContextInterface | null>(null);

export default UserContext;
